import AppStore from "@/app/assets/icons/app-store";
import PlayStore from "@/app/assets/icons/play-store";

interface Props {
    css?: string;
    svgStrokeColor?: "[&_path:nth-child(2)]:fill-black";
    svgStrokeFillColor?: "[&_path]:stroke-black";
}

const DownloadAppPlusIconsWhite = ({ css, svgStrokeColor, svgStrokeFillColor }: Props) => (
    <div
        className={`flex h-12 min-w-16 items-center justify-center gap-s4 ${css} ${svgStrokeColor} ${svgStrokeFillColor}`}
    >
        <AppStore
            className="h-3/6 w-3/6"
            // onClick={() =>
            //     (window.location.href = process.env.ICM_APPLE_APP_URL || "")
            // }
            // onClick={() => window.open(process.env.APP_BRANCH_LINK_HOME, "_blank")}
        />
        <div className="h-2/3 w-[1px] bg-gray-400 opacity-50"></div>
        <PlayStore
            className="h-3/6 w-3/6"
            // onClick={() =>
            //     (window.location.href = process.env.ICM_PLAYSTORE_URL || "")
            // }
            // onClick={() => window.open(process.env.APP_BRANCH_LINK_HOME, "_blank")}
        />
    </div>
);

export default DownloadAppPlusIconsWhite;
